import './ConfiguracoesPage.css'
import Logo from '../Assets/dxpaylogo.png'
import { useEffect, useState } from 'react';
import axios from 'axios';
import axiosInstance from '../Services/Api';
import { useLocation } from 'react-router-dom';

const RegisterPage = () => {
    const [nomeCompleto, setNomeCompleto] = useState('');
    const [nomeUsuario, setNomeUsuario] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [faturamentoMensal, setFaturamentoMensal] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmeSenha, setConfirmeSenha] = useState('');
    const [termosConcordados, setTermosConcordados] = useState(false);
    const [disabled,setDisabled] = useState(false)
    const [referenceCode, setReferenceCode] = useState('');
    const [isReferenceCodeDisabled, setIsReferenceCodeDisabled] = useState(false);

    const location = useLocation(); 
    useEffect(() => {
        // Verifica se há um parâmetro de consulta 'referenceCode' na URL
        const params = new URLSearchParams(location.search);
        const code = params.get('referenceCode');
        if (code) {
            setReferenceCode(code); // Define o valor do referenceCode
            setIsReferenceCodeDisabled(true); 
        }
    }, [location.search]);

    const handleRegister = async (e) => {
        e.preventDefault();
        if (!termosConcordados) {
            alert('Você precisa concordar com os termos e condições');
            return;
        }
        if (senha !== confirmeSenha) {
            alert('As senhas não coincidem');
            return;
        }
        const dados = {
            fullName:nomeCompleto,
            name:nomeUsuario,
            email,
            cpfCnpj:cnpj.replace(/\D/g, ''),
            phone:telefone,
            faturamento:faturamentoMensal.replace(/\D/g, ''),
            password:senha,
            referCode:referenceCode,
        };

        setDisabled(true)
        try {
            await axiosInstance.post('/api/register',dados)
            alert('Registrado com sucesso')
            setDisabled(false)
            window.location.href="/#/login"
        } catch (e) {
            setDisabled(false)
            if (e.response && e.response.status === 422) {
                let errorMessage = '';
            
                // Verifica se cada propriedade existe antes de acessá-la
                if (e.response.data.errors.email) {
                    errorMessage += e.response.data.errors.email + '\n';
                }
                if (e.response.data.errors.phone) {
                    errorMessage += e.response.data.errors.phone + '\n';
                }
                if (e.response.data.errors.fullName) {
                    errorMessage += e.response.data.errors.fullName + '\n';
                }
                if (e.response.data.errors.name) {
                    errorMessage += e.response.data.errors.name + '\n';
                }
                if (e.response.data.errors.faturamento) {
                    errorMessage += e.response.data.errors.faturamento + '\n';
                }
                if (e.response.data.errors.password) {
                    errorMessage += e.response.data.errors.password + '\n';
                }
                if (e.response.data.errors.cpfCnpj) {
                    errorMessage += e.response.data.errors.cpfCnpj + '\n';
                }
            
                // Remove a última quebra de linha, se existir
                errorMessage = errorMessage.trim();
            
                // Exibe a mensagem de erro
                alert(errorMessage);
            }
   
        }

    };

    return (
        <div className="w-full h-screen flex justify-center items-center bg-[#171717]">
            <div className='linear-geadient md:w-[25%]  rounded-[20px] pb-[1px] px-[1px]'>
                <div className='w-full bg-[#1D1D1D] px-8 rounded-[20px]    p-[1px] py-4 '>
                    <div className='w-full flex justify-center mt-3'>
                        <img width={100} src={Logo} />
                    </div>
                    <form onSubmit={handleRegister}>
                        <div className='flex flex-col  text-white mt-4 gap-2'>
                            <div className='flex gap-1 text-[13px]  flex-col'>
                                <label>*nome completo</label>
                                <input
                                    required
                                    type="text"
                                    value={nomeCompleto}
                                    onChange={(e) => setNomeCompleto(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='digite seu nome completo'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>*nome de usuário</label>
                                <input
                                    required
                                    max={14}
                                    type="text"
                                    value={nomeUsuario}
                                    onChange={(e) => setNomeUsuario(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='digite seu nome de usuário'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>*e-mail</label>
                                <input
                                    required
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='digite seu email'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>*telefone</label>
                                <input
                                    required
                                    type="text"
                                    value={telefone}
                                    onChange={(e) => setTelefone(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='digite seu telefone'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>*cnpj</label>
                                <input
                                    required
                                    type="text"
                                    value={cnpj}
                                    onChange={(e) =>    setCnpj(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='digite seu CNPJ'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>*faturamento mensal</label>
                                <input
                                    required
                                    type="number"
                                    value={faturamentoMensal}
                                    onChange={(e) => setFaturamentoMensal(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='digite seu faturamento mensal'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>*senha</label>
                                <input
                                    required
                                    type="password"
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='digite sua senha'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>*confirme senha</label>
                                <input
                                    required
                                    type="password"
                                    value={confirmeSenha}
                                    onChange={(e) => setConfirmeSenha(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='confirme sua senha'
                                />
                            </div>
                            <div className='flex gap-2 text-[13px]  flex-col'>
                                <label>codigo de regerencia</label>
                                <input
                                    type="text"
                                    disabled={isReferenceCodeDisabled}
                                    value={referenceCode}
                                    onChange={(e) => setReferenceCode(e.target.value)}
                                    className='h-[30px]  bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none'
                                    placeholder='Digite o codigo de referência'
                                />
                            </div>
                            <div className='flex gap-1 items-start'>
                                <input
                                    required
                                    type='checkbox'
                                    checked={termosConcordados}
                                    onChange={(e) => setTermosConcordados(e.target.checked)}
                                />
                                <div className='text-center text-[13px]'>
                                    Eu li e concordo com os
                                    <span className='cursor-pointer text-[#478DF8]'> Termos e condições </span>
                                    e a
                                    <span className='cursor-pointer text-[#478DF8]'> Política de Privacidade</span>.
                                </div>
                            </div>
                            <button type='submit' className='bg-[#478DF8] cursor-pointer text-[13px] rounded-[8px] p-2'>{disabled? 'Cadastrando' : 'Cadstrar'}</button>
                            <p className='text-[13px] w-full flex justify-center gap-2'>Já tem uma conta? <a onClick={() => {
                                window.location.href = '/#/login'
                            }} className='cursor-pointer text-[#478DF8]'>Fazer login</a></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default RegisterPage 